<script lang="ts">
	import type { NotificationModel } from '@app/models/app/NotificationsModel';
	import { IconLottie } from '@wiseed/wikit';
	export let props: NotificationModel;
</script>

<li class="py-3">
	<a href={props.linkUrl} class="link">
		<div class="flex gap-3 text-sm justify-between">
			<div class="space-y-2">
				{#if props.title}
					<div class="font-bold">{props.title}</div>
				{/if}
				{#if props.desc}
					<div class="line-clamp-3">
						{props.desc}
					</div>
				{/if}
				<div class="text-primary first-letter:uppercase">{props.linkLabel}</div>
			</div>
			{#if props?.imageUrl?.url}
				<div class="flex-shrink-0 w-[100px] h-[80px]">
					<img class="w-full h-full object-contain" src={props.imageUrl.url} alt="" />
				</div>
			{:else if props.iconName}
				<IconLottie name={props.iconName} size="big" animationOnHover={false} />
			{:else}
				<div
					class="bg-grey-light flex-shrink-0 w-[100px] h-[80px] flex justify-center items-center"
				>
					<IconLottie name="picture" size="big" classNames="text-secondary" />
				</div>
			{/if}
		</div>
	</a>
</li>
